import { useEffect, useRef, type RefObject } from "react"
import { Formik, getIn } from "formik"
import { CharField, SingleSelectField } from "@inmagik/magik-ui"
import * as yup from "yup"
import type { BlockBase, QuoteBlock } from "../../../../types"
import { WysiwygField } from "../../../../components/WysiwygField"
import { AutoValidate } from "./Autovalidate"
import { bgColorOptions } from "../../options"

export function QuoteBlockForm({
  block,
  saveBlock,
  setBlockFormValid,
  submitRef,
}: {
  block: BlockBase
  saveBlock: (b: BlockBase) => void
  setBlockFormValid: (v: boolean) => void
  submitRef: RefObject<HTMLButtonElement | null>
}) {
  const schema = yup.object().shape({
    slideTitle: yup.string().required("Il titolo della slide è obbligatorio"),
    quote: yup.string().required("Il testo della citazione è obbligatorio"),
  })

  const hiddenSubmitRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!submitRef?.current) return
    submitRef.current.onclick = () => hiddenSubmitRef.current?.click()
  }, [submitRef])

  const initialValues: QuoteBlock = {
    uuid: block.uuid,
    blockType: "Quote",
    slideTitle: (block as QuoteBlock).slideTitle ?? "",
    quote: (block as QuoteBlock).quote ?? "",
    author: (block as QuoteBlock).author ?? "",
    color: (block as QuoteBlock).color ?? "",
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validateOnMount
      validationSchema={schema}
      onSubmit={(values) => saveBlock(values)}
    >
      {({ handleSubmit, values, errors, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <CharField
            label="Titolo slide"
            layout="horizontal"
            value={values.slideTitle}
            onChange={(v) => setFieldValue("slideTitle", v)}
            required
            isValid={!getIn(errors, "slideTitle")}
            errorMessage={getIn(errors, "slideTitle")}
            className="mb-3"
          />

          <WysiwygField
            label="Testo citazione"
            layout="horizontal"
            value={values.quote}
            onChange={(v) => setFieldValue("quote", v)}
            required
            isValid={!getIn(errors, "quote")}
            errorMessage={getIn(errors, "quote")}
            className="mb-3"
          />

          <CharField
            label="Autore citazione"
            layout="horizontal"
            value={values.author}
            onChange={(v) => setFieldValue("author", v)}
            isValid={!getIn(errors, "author")}
            errorMessage={getIn(errors, "author")}
            className="mb-3"
          />

          <SingleSelectField
            label="Colore sfondo"
            layout="horizontal"
            options={bgColorOptions}
            value={bgColorOptions.find((o) => o.value === values.color) ?? null}
            onChange={(v) => setFieldValue("color", v?.value ?? "")}
            isValid={!getIn(errors, "color")}
            errorMessage={getIn(errors, "color")}
            placeholder="Seleziona un colore di sfondo"
          />

          <button ref={hiddenSubmitRef} type="submit" style={{ display: "none" }} />
          <AutoValidate setBlockFormValid={setBlockFormValid} />
        </form>
      )}
    </Formik>
  )
}
